import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext/authContext';
import './Layout.css';

const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const toggleDropdown = () => {
    setDropdownVisible((prev) => !prev);
  };

  return (
    <div className="layout-wrapper">
      <header className="site-header">
        {/* Left: Logo */}
        <div className="logo">
          <h1>VBADI</h1>
        </div>

        {/* Middle: Nav Items */}
        <nav className="main-nav">
          <ul>
            <li>
              <Link to="/quiz-time">Quiz Time!</Link>
            </li>
            <li>
              <Link to="/video-hub">Video Hub</Link>
            </li>
            <li>
              <Link to="/zoom-link">Zoom Link</Link>
            </li>
            {user && (user.role === 'Tutor' || user.role === 'Admin') ? (
              <li>
                <Link to="/homework-retrieval">Homework Retrieval</Link>
              </li>
            ) : (
              <li>
                <Link to="/homework-submission">Homework Submission</Link>
              </li>
            )}
          </ul>
        </nav>

        {/* Right: User Menu (if logged in) */}
        {user && (
          <div className="user-menu">
            <button onClick={toggleDropdown} className="user-button">
              {user.role}
            </button>
            {dropdownVisible && (
              <div className="dropdown">
                <button onClick={handleLogout} className="dropdown-item">
                  Sign Out
                </button>
              </div>
            )}
          </div>
        )}
      </header>

      <main className="main-content">{children}</main>
    </div>
  );
};

export default Layout;
